import { render } from "./gastosgeneraleshotel.vue?vue&type=template&id=0f4fd551&scoped=true"
import script from "./gastosgeneraleshotel.vue?vue&type=script&lang=js"
export * from "./gastosgeneraleshotel.vue?vue&type=script&lang=js"

import "./gastosgeneraleshotel.vue?vue&type=style&index=0&id=0f4fd551&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f4fd551"]])

export default __exports__